import { css } from 'styled-components';
import { CFBaseFieldHelpers, CFBaseFieldTokens } from './styles';
export const CFBaseTextFieldStyles = {
    TextFieldWeb: css `
    caret-color: ${CFBaseFieldTokens.CARET_COLOR};
    resize: none;

    &:focus {
      outline-width: 0;
    }

    &::placeholder {
      color: ${CFBaseFieldHelpers.textInputPlaceholderColor};
    }
  `,
};
